import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import StoreSummary from './index';
import { check as anyUserLoggedIn } from '../../utils/tokenUtils';

const StoreSummaryRegistration = (props) => {
  const shouldRender = anyUserLoggedIn();

  if (!shouldRender) return <Navigate to="/registration/outlet" replace/>;

  return <StoreSummary isOnRegistrationPage {...props}/>;
};

const mapStateToProps = state => ({
  registration: state.registration,
});

export default connect(mapStateToProps)(StoreSummaryRegistration);
